import { Link } from '@rumblefish/ui/Rumblefish23Theme';
import parse from 'html-react-parser';
import React from 'react';

import { ScreenReaderText } from '../../../../ui/src/components/ScreenReaderText/ScreenReaderText';
import devaWalletScreen from '../../../public/webp/fromPNG/rumblefish23Theme/devaWalletScreen.webp';
import evmDebuggerScreen from '../../../public/webp/fromPNG/rumblefish23Theme/evmDebuggerScreen.webp';
import { data } from './BlockchainUseCases.data';
import {
  StyledFrame,
  StyledImage,
  StyledStack,
  StyledButton,
  StyledSection,
  StyledHeadline,
  StyledInfoTitle,
  StyledInfoSection,
  StyledInfoWrapper,
  StyledButtonWrapper,
  StyledHeadlineWrapper,
  StyledInfoDescription,
  StyledColumnInfoWrapper,
  StyledSingleInfoWrapper,
} from './styles';
import { StaticImageData } from 'next/image';

const shouldShowWallet = process.env.NEXT_PUBLIC_SHOW_DEVIL_WALLET === 'true';

export const BlockchainUseCases = () => {
  return (
    <StyledSection width="normal">
      <StyledStack>
        <StyledFrame>
          <>
            <StyledHeadlineWrapper>
              <StyledHeadline variant="display_sm">
                {data.devaWallet.headline.title}
              </StyledHeadline>
            </StyledHeadlineWrapper>

            <StyledInfoSection bottomMargin>
              <StyledColumnInfoWrapper>
                {data.devaWallet.infoSections.map(
                  (section, indexSingleInfo) => (
                    <StyledSingleInfoWrapper key={indexSingleInfo}>
                      <StyledInfoTitle variant="strong_500">
                        {section.title}
                      </StyledInfoTitle>
                      <StyledInfoDescription variant="regular_400">
                        {parse(section.description || '')}
                      </StyledInfoDescription>
                    </StyledSingleInfoWrapper>
                  )
                )}
                <StyledSingleInfoWrapper>
                  <StyledButtonWrapper>
                    <Link to="/case-studies/deva-wallet">
                      <StyledButton>
                        Learn more{' '}
                        <ScreenReaderText>
                          Learn more about Deva Wallet
                        </ScreenReaderText>
                      </StyledButton>
                    </Link>
                  </StyledButtonWrapper>
                </StyledSingleInfoWrapper>
              </StyledColumnInfoWrapper>
              <StyledInfoWrapper>
                <StyledImage
                  src={(devaWalletScreen as unknown as StaticImageData)?.src}
                  alt="deva-wallet-app-showcase"
                />
              </StyledInfoWrapper>
            </StyledInfoSection>
          </>

          <StyledHeadlineWrapper>
            <StyledHeadline variant="display_sm">
              {data.evmDebugger.headline.title}
            </StyledHeadline>
          </StyledHeadlineWrapper>

          <StyledInfoSection reverse={shouldShowWallet}>
            <StyledColumnInfoWrapper>
              {data.evmDebugger.infoSections.map((section, indexSingleInfo) => (
                <StyledSingleInfoWrapper
                  reverse={shouldShowWallet}
                  key={indexSingleInfo}>
                  <StyledInfoTitle variant="strong_500">
                    {section.title}
                  </StyledInfoTitle>
                  <StyledInfoDescription variant="regular_400">
                    {parse(section.description || '')}
                  </StyledInfoDescription>
                </StyledSingleInfoWrapper>
              ))}
              <StyledSingleInfoWrapper reverse={shouldShowWallet}>
                <StyledButtonWrapper>
                  <Link to="/evm-debugger">
                    <StyledButton>TRY OUT THE EVM DEBUGGER</StyledButton>
                  </Link>
                </StyledButtonWrapper>
              </StyledSingleInfoWrapper>
            </StyledColumnInfoWrapper>
            <StyledInfoWrapper>
              <StyledImage
                reverse={shouldShowWallet}
                src={(evmDebuggerScreen as unknown as StaticImageData)?.src}
                alt="evm-debugger-app-showcase"
              />
            </StyledInfoWrapper>
          </StyledInfoSection>
        </StyledFrame>
      </StyledStack>
    </StyledSection>
  );
};
